import { Component, Inject, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { WrapperStandardRequest } from 'src/app/infrastructure/infrastructure-services/common/models/wrapper.model';

import { BaseService } from 'src/app/infrastructure/infrastructure-services/services/base/base-service';
import { GenericService } from 'src/app/infrastructure/infrastructure-services/services/base/generic-service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericCflViewComponent } from 'src/app/infrastructure/infrastructure-services/generics/generic-cfl-view/generic-cfl-view.component';
import { NgxIndexedDBService, ObjectStoreMeta } from 'ngx-indexed-db';
import { HttpClient } from '@angular/common/http';
import { elementAt } from 'rxjs';
import { LoginApiMasterService } from '../Service/login-api-master.service';
import { LoginModel, LoginReqPayload, ReVerifyReqPayload, ReVerifyRequest, secuirtyloginRequestData } from 'src/app/core/models/masters/login.model';
import { SecurityService } from '../Service/security.service';
import { GlobalProperties } from 'src/app/global/global-properties';

import { WrapperStandardFilter } from 'src/app/infrastructure/infrastructure-services/common/models/wrapper.model';
import { OidcClientManagerService } from '../service-oidc/oidc-client-manager.service';
import { json } from 'body-parser';
@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class LoginPageComponent implements OnInit {
  // translate: any;
  masterMenuLayout: any;
  _URL: any;
  Request_Data: any;
  selectLanguageValue:any
  _lstItem: any[] = [];
  _decimallstitem: any;
  loginForm!: FormGroup;
  isDisabled: boolean = false;
  isPwdVisible: boolean = false;
  currentUserInfo:any
 loginWithSSO:boolean=false;
  isSSOLogin:boolean=false;
  oneLogin:boolean=false
  // queryParamsvalue: String = 'skjdhhkjshdhsdksd+Clientsecret=sfs54f65s4f65s65f46s543534654sf';

companyList: any[] = []; // Initialize companyList to an empty array
    selectedCompany: any = '';
    selectedCompanyData: any = null; // Initialize selectedCompanyData to nul
  windowHeight: number = window.innerHeight;

  constructor(public translate: TranslateService, private router: Router,
    private oidcClientManager: OidcClientManagerService,
    public generic: GenericService<any>,
    public matDialogRefForCfl: MatDialogRef<GenericCflViewComponent<any>>,
    public agenericRepositoryForCfl: GenericService<any>,
    public routerForCfl: Router, private dbService: NgxIndexedDBService,
    private securityService: SecurityService,
    @Inject(MAT_DIALOG_DATA) private data: any,
    public matDialogforCfl: MatDialog, private http: HttpClient, private loginService: LoginApiMasterService,
    private fb: FormBuilder) {
    this.translate.setDefaultLang('en');
   const url = window.location.href;
        if (url.includes('/#state=')) {
            this.loginSSO();
            setTimeout(()=>{

                this.isSSOLogin=true;

            },1000)        }
        else{
          this.isSSOLogin=true;
        }
  }

   ngOnInit() {
   this.selectLanguageValue='en';
    this.createForm();
    this.initLoginConfig();
  this.changeLanguage('en')
    
  }


  async initLoginConfig() {
   this.oneLogin = await this.loginService.readConfigsingleLoginForAllUser('assets/config.json');
  
 
}
  //add tanuj(decimal places value)
  DecimalApiCall(): any {
    const storeSchema: ObjectStoreMeta = {
      store: 'Decimal_Places',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: []
    };
    this.dbService.deleteObjectStore('Decimal_Places');
    this.dbService.createObjectStore(storeSchema);

    this.Request_Data = {
      "userId": 0,
      "userGuid": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      "companyCode": "BaseDBConnection",
      "requestData": null,
      "pageRecordCount": 100,
      "pageSize": 1,
      "isAcending": true,
      "sortColumn": "Code"
    };
    this._URL = `${GlobalProperties.getApiUrl}:81/api/V1.0/GeneralSettings/GetGeneralSettingsListService`;
    this.http.post(this._URL, this.Request_Data, { withCredentials: true }).
      subscribe((res: any) => {
        this._lstItem = res.responseData;
        this.setDataToIndexDB();
      });
  }

  // add Tanuj
  setDataToIndexDB() {
    //add enum list api response object in index DB
    this.dbService.deleteObjectStore('Decimal_Places');
    this.dbService.clear('Decimal_Places').subscribe((successDeleted) => {
     
    });

    //data add indexDB
    this.dbService.add('Decimal_Places', this._lstItem).subscribe((key) => {
    
    });

    //data get indexed DB
    this._decimallstitem = this.dbService.getAll('Decimal_Places').subscribe((element) => {
    
    })

    // Local Storage Add Data  (Indexdb show version error)
    localStorage.removeItem('Absolute');
    localStorage.setItem("Decimal_Value", JSON.stringify(this._lstItem));
   
  }

  changeLanguage(event: any) {
 
   
    this.translate.use(event);
    this.translate.setDefaultLang(event);
    localStorage.setItem('lang', event);
   
  
  }

  onOpenDropDown(value: any) {
    let genCFL = new GenericCflViewComponent<any>(this.agenericRepositoryForCfl, this.routerForCfl, this.matDialogforCfl, this.matDialogRefForCfl, this.data, this.dbService);
      let filter: WrapperStandardFilter = new WrapperStandardFilter();
    if (value == 'Branch') {
      genCFL.setCflTitle = "Select Default Branch";
      genCFL.setCflViewDataSourceURL = 'Branch/GetBranchListService';
      genCFL.setCflDisplayedColumnsNamesList = ['branchName', 'stateName', 'countryName'];
      // genCFL.setCflSelectedData = this.selectedData;
      
      genCFL.setCFLIsCancel = false
      genCFL.setSortColumn = "branchName";
       
    }

    filter.Key = 'disabled';
    filter.OperatorType = 'contains';
    filter.Value = 'N'
    genCFL.setCflFilterArray = filter;
    
    genCFL.openCFL(GenericCflViewComponent, {}).afterClosed().subscribe(res => {
    
      if (res != undefined && res.event != undefined) {
        if (value == 'Branch') {
          localStorage.setItem("BranchId", res.event.bplid);
          localStorage.setItem("BranchName", res.event.branchName);
          localStorage.setItem("branchRegNo", res.event.federalTaxID);
        }
      }
    })
  }

  switchLang(lang: string) {
   
    let langCheck = '';
    this.translate.use(lang);

    langCheck = lang;
    this.masterMenuLayout.setOption(langCheck);
    window.location.reload();
  }



  callSAPLoginAPI(sapDetails:any) {

    // let mdata = 'https://hana93.uneecopscloud.com:50000/b1s/v2/';
    let mdata = `${sapDetails.ServiceLayerURL}Login`;
    // let mdata = 'https://hana93.uneecopscloud.com:50000/b1s/v2/Login';
    if (mdata) {
     
      var data = {
        CompanyDB: `${sapDetails.CompanyDB}`,
        UserName: `${sapDetails.UserName}`,
        Password: `${sapDetails.Password}`
      }

      this.generic.PostAPIWithOptions(mdata, data, { withCredentials: true }).then((res: any) => {
        if (res["SessionId"] != null) {
          localStorage.setItem("SAPsessionId", res["SessionId"]);
            this.router.navigate(['/home']);

              this.onOpenDropDown('Branch');
        }
      });
    }
  }

    oneLoginForAllUser(sapDetails:any) {
     sessionStorage.setItem("OneLoginUser", 'true');
    // let mdata = 'https://hana93.uneecopscloud.com:50000/b1s/v2/';
    let mdata = `${sapDetails.ServiceLayerURL}Login`;
    // let mdata = 'https://hana93.uneecopscloud.com:50000/b1s/v2/Login';
    if (mdata) {
     
      var data = {
        CompanyDB: `${sapDetails.CompanyDB}`,
        UserName: `${GlobalProperties._oneLoginUserName}`,
        Password: `${GlobalProperties._oneLoginPassword}`
      }

      this.generic.PostAPIWithOptions(mdata, data, { withCredentials: true }).then((res: any) => {
        if (res["SessionId"] != null) {
          localStorage.setItem("SAPsessionId", res["SessionId"]);
        }
      });
    }
  }

  // **** Form Starts ****

  public createForm() {
    this.loginForm = this.fb.group({
      userName: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });
  }

  // **** Form Ends ****


  // **** Login Starts ****

  async login() {
       localStorage.clear()
    sessionStorage.clear()

    this.changeLanguage(this.selectLanguageValue);
    if (this.loginForm.valid){

   
  
    sessionStorage.setItem('loginWithSSO', 'false');
    this.loginWithSSO = false;
    if(await this.loginService.readConfigDataFromApi('assets/config.json')){

      sessionStorage.setItem('data-from-api', 'true')
      this.reVerifyMethod(await (this.loginMethod() as Promise<{ value: any, loginModel: LoginModel }>));

    }
    else{

    
      this.userLoginSecuirtyService();

    }
    
   }
   
  }
  // **** Login Ends ****


  public async loginMethod() {
    let loginModel = new LoginModel();
    let loginPayLoad: LoginReqPayload = new LoginReqPayload();
    loginModel.companyCode=GlobalProperties.getcompnayCode
    loginPayLoad.ModuleSecret = this.securityService.moduleSecret;
    loginPayLoad.ModuleId = this.securityService.moduleid;
    loginPayLoad.UserName = this.loginForm.get('userName')?.value;
    loginPayLoad.UserPassword = this.loginForm.get('password')?.value;
    loginModel.requestData = this.securityService.encryptWithPublicKey(JSON.stringify(loginPayLoad));

    try {
      return { value: await this.loginService.login(loginModel), loginModel: loginModel };
    } catch (error) {
      this.isDisabled = false;
      return
    }
  }


  public reVerifyMethod(loginResponse: { value: any, loginModel: LoginModel}) {
  
   loginResponse.value.UserName = this.loginForm.get('userName')?.value;
  
    sessionStorage.setItem('currentUser', JSON.stringify(loginResponse?.value))
    sessionStorage.setItem('UserGuid',loginResponse?.loginModel.userGuid);
    let reVerifyPayLoad: ReVerifyReqPayload = new ReVerifyReqPayload();

    let decryptedMessage = JSON.parse(this.securityService.decryptWithPrivateKey(loginResponse.value.resMessage.split("token=")[1]));
    reVerifyPayLoad.AUTHTOKEN = loginResponse.value.authToken;
    reVerifyPayLoad.MODULEID = decryptedMessage.ModuleId;
    reVerifyPayLoad.GUID = decryptedMessage.GUID;
    reVerifyPayLoad.MODULESECRET = decryptedMessage.ModuleSecret;
    reVerifyPayLoad.REDIRECTURL = decryptedMessage.RedirectURL;
    let newRequestData: ReVerifyRequest = new ReVerifyRequest();
    newRequestData.LoginDate = loginResponse.value.loginDate;
    newRequestData.ReqMessage = this.securityService.encryptWithPublicKey(JSON.stringify(reVerifyPayLoad));

    loginResponse.loginModel.userGuid = decryptedMessage.GUID;
    loginResponse.loginModel.companyGuid = decryptedMessage.CompanyGuId;
    loginResponse.loginModel.requestData = newRequestData
//APIGatewayURL
    this.loginService.reVerify(loginResponse.loginModel).subscribe((res: any) => {
      let decryptedMessage = JSON.parse(this.securityService.decryptWithPrivateKey(res.responseData.sapDetails));
      console.log('decryptedMessage',decryptedMessage)
      sessionStorage.setItem('companyGUID',decryptedMessage.CompanyGuId);
      sessionStorage.setItem('companydb',decryptedMessage.CompanyDB);
      sessionStorage.setItem('roleMenus', JSON.stringify(res?.responseData.roleMenu))
     let decryptedMessageSAP = JSON.parse(this.securityService.decryptWithPrivateKey(res?.responseData.sapDetails));
     sessionStorage.setItem('sapDetails', res?.responseData.sapDetails)
      this.isDisabled = false;
      this.router.navigate(['/home']);
      this.callSAPLoginAPI(decryptedMessageSAP);
      this.onOpenDropDown('Branch');
    });
  }
 
  public async userLoginSecuirtyService(){

   
    let loginModel = new LoginModel();
    let loginRequestDat: secuirtyloginRequestData = new secuirtyloginRequestData();
    let sapDetails:any=GlobalProperties.getSapInfo;
    sapDetails['UserName']=this.loginForm.get('userName')?.value;
    sapDetails['Password']=this.loginForm.get('password')?.value;
    loginRequestDat.ServiceLayerUrl=sapDetails['ServiceLayerURL']+'Login';
    loginRequestDat.CompanyDB=sapDetails['CompanyDB'];
    loginRequestDat.UserName=this.loginForm.get('userName')?.value;
    loginRequestDat.Password=this.loginForm.get('password')?.value;
    loginRequestDat.ManagerUserName=GlobalProperties.getManagerUserName
    loginModel.companyCode=GlobalProperties.getcompanyCodeSecuirtyService
    loginModel.requestData=loginRequestDat;
    loginModel.sortColumn=GlobalProperties.getcompanyCodeSecuirtyService;
  
   
    this.loginService.userlogin(loginModel).subscribe((res: any) => {
      if (!res) return
      res['UserName']=this.loginForm.get('userName')?.value;
      res['Password']=this.loginForm.get('password')?.value;
      sessionStorage.setItem('currentUser', JSON.stringify(res));

      // GlobalProperties._userGUID=res.userGuId;
     if(res.userGuId){

          sessionStorage.setItem('UserGuid',res.userGuId);

       }
       else{

          sessionStorage.setItem('UserGuid','3fa85f64-5717-4562-b3fc-2c963f66afa6');

       }
        sessionStorage.setItem('roleType',res.roleType);
      
      this.isDisabled = false;
      sessionStorage.setItem('roleMenus', JSON.stringify(res.roleMenuList));
     this.oneLogin ?this.oneLoginForAllUser(sapDetails):this.callSAPLoginAPI(sapDetails);
    

    
   
    
     
     
    })


  }
   public async userLoginSecuirtyServiceForSSO(userCode:string){

   
    let loginModel = new LoginModel();
    let loginRequestDat: secuirtyloginRequestData = new secuirtyloginRequestData();
    let sapDetails:any=GlobalProperties.getSapInfo;
    sapDetails['UserName']=this.loginForm.get('userName')?.value;
    sapDetails['Password']=this.loginForm.get('password')?.value;
    loginRequestDat.ServiceLayerUrl=sapDetails['ServiceLayerURL']+'Login';
    loginRequestDat.CompanyDB=sapDetails['CompanyDB'];
    loginRequestDat.UserName=userCode;
    loginRequestDat.Password=userCode; 
  
    loginRequestDat.ManagerUserName=GlobalProperties.getManagerUserName
    loginModel.companyCode=GlobalProperties.getcompanyCodeSecuirtyService
    loginModel.requestData=loginRequestDat;
    loginModel.sortColumn=GlobalProperties.getcompanyCodeSecuirtyService;
  
   
    this.loginService.userlogin(loginModel).subscribe((res: any) => {
      if (!res) return
      res['UserName']=userCode;
      res['Password']=userCode;
      sessionStorage.setItem('currentUser', JSON.stringify(res));
       if(res.userGuId){

          sessionStorage.setItem('UserGuid',res.userGuId);

       }
       else{

          sessionStorage.setItem('UserGuid','3fa85f64-5717-4562-b3fc-2c963f66afa6');

       }
     
        sessionStorage.setItem('roleType',res.roleType);
      this.isDisabled = false;
      sessionStorage.setItem('roleMenus', JSON.stringify(res.roleMenuList));
      this.router.navigate(['/home']);
   
      this.onOpenDropDown('Branch');

      this.getSapAccessToken()
    
   
    
     
     
    })


  }














 






   async loginSSO() {
  
   
      sessionStorage.setItem('loginWithSSO', 'true');
    this.loginWithSSO = true;
  //  this.loginForm.reset({userName:' ',password:''});
    
    
        const clientSettings = {
            // Add your required OIDC client settings here
  //  client_id: 'b1-ext-0117680e-d806-4fc6-9501-6fb2f023ab0b', //localhost 3300
  client_id: 'b1-ext-7a025106-cd2c-4727-a9e1-0a3d5712a078', //erp.ubshanacloud.in
        };
        let sldAddress = "https://ubsdemo.ubshanacloud.in:40000/sld/sld0100.svc";

        this.oidcClientManager.init(clientSettings, sldAddress + '/GetOpenIDConnectProvider', sldAddress + '/CurrentUserInfo')
            .then(() => {
                this.oidcClientManager.getBindingCompaniesInfo()
                    .then((companyListRes: any) => {
                        // Call your UI binding function here, e.g.:
                        // this.bindCompanyListUI(companyList);
                       let sapInfo:any=GlobalProperties.getSapInfo;
                        this.currentUserInfo=companyListRes.d.CurrentUserInfo.UserName;
                        this.companyList = companyListRes.d.CurrentUserInfo.B1UserBindings.results; // Store the company list in the component property
                   
                        
                         this.companyList=this.companyList.filter(res=>{

                         return res.CompanySchemaName==sapInfo.CompanyDB

                         })
                      })
                    .catch((err: any) => {
                        alert("get binding user info failed: " + err);
                    });
            })
            .catch((err: any) => {
                if (err.message === "access_denied") {
                    alert("Current user does not have permission to access company");
                    this.oidcClientManager.startSignoutRedirect();
                } else {
                    alert(err);
                }
            });

    }
    // Add login logic here if needed
    onCompanyChange(data: any) {
        console.log("Company change event data:", data);
        console.log("Company changed:", data?.CompanyID);
        sessionStorage.setItem("companyID", data?.CompanyID || '');
        const selectedCompany = data?.CompanyID;
        console.log("Company changed:", selectedCompany);
        if (selectedCompany) {
            this.selectedCompany = selectedCompany;
            this.chooseCompanyForm(selectedCompany);
        } else {
            console.warn("Selected company not found in companyList");
        }
    }

    chooseCompanyForm(companyID: string) {
        var compData = this.companyList.find((company: any) => company.CompanyID === companyID);
        this.selectedCompanyData = compData; // Store the selected company data
        console.log("Selected company data:", this.selectedCompanyData);
        console.log("Company data:", compData);

        this.getEmployeCodeOnTheBasisOfEmail(this.currentUserInfo)
       // this.getEntitiesTest();
      

    }

  

    getEntities(name: string) {
        const companyID = sessionStorage.getItem("companyID");
        if (!companyID) {
            alert("No companyID found in sessionStorage");
            return;
        }
        const slBaseUrl = "https://ubsdemo.ubshanacloud.in:50000/b1s/v2/";
        const url = `${slBaseUrl}${name}?$top=1`;
        const headers: Record<string, string> = {
            "x-b1-companyid": encodeURIComponent(companyID)
        };

        // Get access token from oidcClientManager
        this.oidcClientManager.getAccessToken().then((accessToken: string) => {
            if (accessToken) {
                headers['Authorization'] = `Bearer ${accessToken}`;
            }
            headers['Content-Type'] = 'application/json';
            this.http.get(url, { headers }).subscribe({
                next: (data) => {
                    console.log(JSON.stringify(data));
                },
                error: (error) => {
                    console.log(JSON.stringify(error));
                }
            });
        }).catch((err: any) => {
            console.error('Failed to get access token:', err);
        });
    }


    getSapAccessToken() {
        const companyID = sessionStorage.getItem("companyID");
        if (!companyID) {
            alert("No companyID found in sessionStorage");
            return;
        }
        // Get access token from oidcClientManager
        this.oidcClientManager.getAccessToken().then((accessToken: string) => {
         
            if (accessToken) {
                 sessionStorage.setItem('sapToken',JSON.stringify(accessToken))
            }
        }).catch((err: any) => {
            console.error('Failed to get access token:', err);
        });
    }


    preventEnter(event:any) {
  event.preventDefault();
}


getEmployeCodeOnTheBasisOfEmail(email:string){

  let payload = new WrapperStandardRequest();
  payload.RequestData=email;

       this.http.post(GlobalProperties.getApiUrl + 'Security/GetUserCodeByEmailService',payload )
        .subscribe((res:any) => {
        
       let userCode=res.responseData.userCode;

     this.userLoginSecuirtyServiceForSSO(userCode)


        });



  }
}
